/* Taxonomie NelDaari — MIROIR de backend/seed_data.py.
   3 axes distincts (listes contrôlées, valeurs normalisées) :
   - CUISINE_TYPES : identité du restaurant (1 à 3 max)
   - SPECIALTIES   : plats / familles de plats (plusieurs)
   - DISCOVERY     : catégories de découverte (accueil + recherche), auto-déduites. */

export const CUISINE_TYPES = [
  { v: "guineenne", fr: "Guinéenne", en: "Guinean" },
  { v: "africaine", fr: "Africaine", en: "African" },
  { v: "ivoirienne", fr: "Ivoirienne", en: "Ivorian" },
  { v: "senegalaise", fr: "Sénégalaise", en: "Senegalese" },
  { v: "libanaise", fr: "Libanaise", en: "Lebanese" },
  { v: "francaise", fr: "Française", en: "French" },
  { v: "italienne", fr: "Italienne", en: "Italian" },
  { v: "asiatique", fr: "Asiatique", en: "Asian" },
];

export const SPECIALTIES = [
  { v: "riz_gras", fr: "Riz gras", en: "Riz gras" },
  { v: "riz_sauce", fr: "Riz sauce", en: "Rice & sauce" },
  { v: "mafe", fr: "Mafé", en: "Mafé" },
  { v: "sauce_feuille", fr: "Sauce feuille", en: "Leaf sauce" },
  { v: "sauce_arachide", fr: "Sauce arachide", en: "Peanut sauce" },
  { v: "sauce_gombo", fr: "Sauce gombo", en: "Okra sauce" },
  { v: "fouti", fr: "Fouti", en: "Fouti" },
  { v: "attieke", fr: "Attiéké", en: "Attiéké" },
  { v: "poisson_braise", fr: "Poisson braisé", en: "Braised fish" },
  { v: "poulet_braise", fr: "Poulet braisé", en: "Braised chicken" },
  { v: "grillades", fr: "Grillades", en: "Grills" },
  { v: "brochettes", fr: "Brochettes", en: "Skewers" },
  { v: "poulet_frit", fr: "Poulet frit", en: "Fried chicken" },
  { v: "burger", fr: "Burger", en: "Burger" },
  { v: "pizza", fr: "Pizza", en: "Pizza" },
  { v: "tacos", fr: "Tacos", en: "Tacos" },
  { v: "shawarma", fr: "Shawarma", en: "Shawarma" },
  { v: "sandwichs", fr: "Sandwichs", en: "Sandwiches" },
  { v: "patisseries", fr: "Pâtisseries", en: "Pastries" },
];

export const DISCOVERY = [
  { v: "plats_guineens", fr: "Plats guinéens", en: "Guinean dishes" },
  { v: "grillades", fr: "Grillades", en: "Grills" },
  { v: "poulet", fr: "Poulet", en: "Chicken" },
  { v: "poisson", fr: "Poisson", en: "Fish" },
  { v: "plats_africains", fr: "Plats africains", en: "African dishes" },
  { v: "fastfood", fr: "Fast-food", en: "Fast food" },
  { v: "burgers", fr: "Burgers", en: "Burgers" },
  { v: "pizza", fr: "Pizza", en: "Pizza" },
  { v: "tacos", fr: "Tacos", en: "Tacos" },
  { v: "sandwichs_shawarma", fr: "Sandwichs & Shawarma", en: "Sandwiches & Shawarma" },
  { v: "petitdej", fr: "Petit-déjeuner", en: "Breakfast" },
  { v: "patisseries_desserts", fr: "Pâtisseries & desserts", en: "Pastries & desserts" },
  { v: "boissons_jus", fr: "Boissons & jus", en: "Drinks & juices" },
  { v: "cafe", fr: "Café", en: "Coffee" },
  { v: "internationale", fr: "Cuisine internationale", en: "International cuisine" },
];

/* Déduction découverte — miroir de seed_data.derive_discovery */
const DERIVE = {
  guineenne: ["plats_guineens"],
  africaine: ["plats_africains"], ivoirienne: ["plats_africains"], senegalaise: ["plats_africains"],
  libanaise: ["sandwichs_shawarma"],
  francaise: ["internationale"], italienne: ["internationale"],
  asiatique: ["internationale"], internationale: ["internationale"],
  fastfood: ["fastfood"],
  riz_gras: ["plats_guineens"], riz_sauce: ["plats_guineens"], mafe: ["plats_guineens"],
  sauce_feuille: ["plats_guineens"], sauce_arachide: ["plats_guineens"],
  sauce_gombo: ["plats_guineens"], fouti: ["plats_guineens"],
  attieke: ["plats_africains"],
  poisson_braise: ["poisson", "grillades"],
  poulet_braise: ["poulet", "grillades"],
  grillades: ["grillades"], brochettes: ["grillades"],
  poulet_frit: ["poulet", "fastfood"],
  burger: ["burgers", "fastfood"],
  pizza: ["pizza"], tacos: ["tacos", "fastfood"],
  shawarma: ["sandwichs_shawarma"], sandwichs: ["sandwichs_shawarma"],
  patisseries: ["patisseries_desserts"],
};

export const deriveDiscovery = (cuisines = [], specialties = []) => {
  const out = [];
  [...cuisines, ...specialties].forEach((k) => {
    (DERIVE[k] || []).forEach((d) => { if (!out.includes(d)) out.push(d); });
  });
  return out;
};

/* Anciens slugs (taxonomie 2025) → libellés, pour l'affichage des données historiques */
const LEGACY_LABELS = {
  ouest_africaine: { fr: "Ouest-africaine", en: "West African" },
  malienne: { fr: "Malienne", en: "Malian" },
  mediterraneenne: { fr: "Méditerranéenne", en: "Mediterranean" },
  maghrebine: { fr: "Maghrébine", en: "North African" },
  americaine: { fr: "Américaine", en: "American" },
  indienne: { fr: "Indienne", en: "Indian" },
  chinoise: { fr: "Chinoise", en: "Chinese" },
  japonaise_sushi: { fr: "Japonaise / Sushi", en: "Japanese / Sushi" },
  vietnamienne: { fr: "Vietnamienne", en: "Vietnamese" },
  turque: { fr: "Turque", en: "Turkish" },
  grillades_braises: { fr: "Grillades & braisés", en: "Grills & braised" },
  poissons_fruits_mer: { fr: "Poissons & fruits de mer", en: "Fish & seafood" },
  streetfood: { fr: "Street-food", en: "Street food" },
  shawarma_kebab: { fr: "Shawarma / Kebab", en: "Shawarma / Kebab" },
  boulangerie: { fr: "Boulangerie", en: "Bakery" },
  patisserie: { fr: "Pâtisserie", en: "Pastry" },
  glaces: { fr: "Glaces", en: "Ice cream" },
  desserts: { fr: "Desserts", en: "Desserts" },
  jus_boissons: { fr: "Jus & boissons", en: "Juices & drinks" },
  healthy_salades: { fr: "Healthy / Salades", en: "Healthy / Salads" },
  vegetarien: { fr: "Végétarien", en: "Vegetarian" },
  autre: { fr: "Autre cuisine", en: "Other cuisine" },
  guineen: { fr: "Guinéenne", en: "Guinean" }, africain: { fr: "Africaine", en: "African" },
};

const ALL = [...CUISINE_TYPES, ...SPECIALTIES, ...DISCOVERY];

export const cuisineLabel = (v, lang = "fr") => {
  const c = ALL.find((x) => x.v === v);
  if (c) return lang === "en" ? c.en : c.fr;
  const l = LEGACY_LABELS[v];
  return l ? (lang === "en" ? l.en : l.fr) : v;
};

/* Compat : anciens imports `CUISINES` (formulaires historiques) */
export const CUISINES = [
  ...CUISINE_TYPES.map((c) => ({ ...c, type: "cuisine", popular: true })),
  ...SPECIALTIES.map((s) => ({ ...s, type: "specialty", popular: false })),
];
